import AuthService from '../services/auth.service';

const user = JSON.parse(sessionStorage.getItem('user'));
     
const initialState = user
    ? { status: { loggedIn: true }, user, checked: false }
    : { status: { loggedIn: false }, user: null, checked: false };

export const auth = {
    namespaced: true,
    state: initialState,
    actions: {
        login({ commit }, user) {
            return AuthService.login(user).then(
                user => {
                    commit('loginSuccess', user);
                    /*dispatch('acs/checkPendingTrans', null, {root: true});*/
                    return Promise.resolve(user);
                },
                error => {
                    commit('loginFailure');
                    return Promise.reject(error);
                }
            );
        },
        logout({ commit }) {
            AuthService.logout();
            commit('logout');
        },
        checked({ commit }) {
            commit('checked');
        },
        ssoLogin({ commit }, user) {
            return AuthService.ssoLogin(user).then(
                user => {
                    commit('loginSuccess', user);
                    //dispatch('acs/checkPendingTrans', null, {root: true});
                    return Promise.resolve(user);
                },
                error => {
                    commit('loginFailure');
                    return Promise.reject(error);
                }
            );
        },
    },
    mutations: {
        loginSuccess(state, user) {
            state.status.loggedIn = true;
            state.user = user;
        },
        loginFailure(state) {
            state.status.loggedIn = false;
            state.user = null;
        },
        logout(state) {
            state.status.loggedIn = false;
            state.user = null;
        },
        checked(state) {
            state.checked = true;
        },
    }
};
